import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import {
  ProfileScreenRoute,
  ShareScreenRoute,
  DeleteScreenRoute,
} from "./routes";
import ProfileScreen from "../../screens/Profile/Profile";
import ShareScreen from "../../screens/ShareScreen/ShareScreen";
import DeleteUserScreen from "../../screens/DeleteUser/DeleteUserScreen";

export type ProfileStackParams = {
  [ProfileScreenRoute]: undefined;
  [ShareScreenRoute]: undefined;
  [DeleteScreenRoute]: undefined;
};

const { Navigator, Screen } = createNativeStackNavigator<ProfileStackParams>();

const ProfileStack = () => {
  return (
    <Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Screen name={ProfileScreenRoute} component={ProfileScreen} />
      <Screen name={ShareScreenRoute} component={ShareScreen} />
      <Screen name={DeleteScreenRoute} component={DeleteUserScreen} />
    </Navigator>
  );
};

export default ProfileStack;
